
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.76 8.13h4.2v14.65h-4.2V8.13zm2-1.83h-.03c-1.52 0-2.51-1.12-2.51-2.54 0-1.45 1.02-2.54 2.57-2.54 1.55 0 2.5 1.09 2.53 2.54 0 1.42-.98 2.54-2.56 2.54zm19.02 16.48h-4.77V15.2c0-1.98-.75-3.34-2.38-3.34-1.25 0-1.95.91-2.28 1.79-.12.31-.1.76-.1 1.2v7.93H8.53s.06-13.43 0-14.65h4.72v2.3c.28-1.01 1.79-2.44 4.2-2.44 2.99 0 5.33 2.11 5.33 6.64v8.15z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    